import { createFileRoute } from "@tanstack/react-router";
import EnrollSession from "@/pages/EnrollSession";

export const Route = createFileRoute("/_authenticated/enroll/$sessionId")({
  head: () => ({
    meta: [
      { title: "Aanmelden voor sessie | De Hussel App" },
      { name: "description", content: "Meld je aan voor deze hussel-sessie bij je tennisclub." },
      { property: "og:title", content: "Aanmelden voor sessie | De Hussel App" },
      { property: "og:description", content: "Meld je aan voor deze hussel-sessie bij je tennisclub." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: EnrollSession,
});
